/**
 * MobileMenuWrapper.jsx
 * Created by michaelbray on 5/7/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import MobileMenu from './MobileMenu';

const propTypes = {
    showMobileMenu: PropTypes.bool,
    clickedMobileMenuButton: PropTypes.func,
    logout: PropTypes.func,
    cart: PropTypes.object,
    auth: PropTypes.shape({
        account: PropTypes.shape({
            account: PropTypes.object
        })
    }),
    previewBannerHeight: PropTypes.number
};

const defaultProps = {
    showMobileMenu: false,
    cart: {},
    auth: {
        account: {
            account: {}
        }
    },
    previewBannerHeight: 0
};

export default class MobileMenuWrapper extends React.Component {
    render() {
        let content = null;
        let account = null;
        if (this.props.auth.account) {
            account = this.props.auth.account.account;
        }

        if (this.props.showMobileMenu) {
            content = (
                <MobileMenu
                    clickedMobileMenuButton={this.props.clickedMobileMenuButton}
                    logout={this.props.logout}
                    cart={this.props.cart}
                    account={account}
                    previewBannerHeight={this.props.previewBannerHeight} />
            );
        }

        return (
            <div className="nav-mobile-menu-wrapper">
                <CSSTransitionGroup
                    transitionName="mobile-menu-slide"
                    transitionLeaveTimeout={300}
                    transitionEnterTimeout={300}
                    transitionLeave>
                    {content}
                </CSSTransitionGroup>
            </div>
        );
    }
}

MobileMenuWrapper.propTypes = propTypes;
MobileMenuWrapper.defaultProps = defaultProps;
